import moment from 'moment'

export const getDateObjectFromPeriodString = (periodString) => {
  const month = periodString.split('/')[0]
  const year = periodString.split('/')[1]
  return new Date(year, month, 0)
}

export const getYearAndMonthStringFromDateObject = (dateObject) => {
  const month = dateObject.toLocaleString('en-us', { month: 'long' })
  const year = dateObject.toLocaleString('en-us', { year: 'numeric' })

  return {
    month,
    year,
  }
}

export const getYearAndMonthStringFromPeriodString = (periodString) => {
  return getYearAndMonthStringFromDateObject(getDateObjectFromPeriodString(periodString))
}

export const isDateInRange = (originalDate, startDate, endDate) => {
  return startDate <= originalDate && originalDate <= endDate
}

export const mergeOverlappingUnixDateIntervals = (unixIntervals) => {
  if (unixIntervals.length < 2) {
    return unixIntervals
  }

  unixIntervals.sort((a, b) => a[0] - b[0])

  const result = []
  let previous = unixIntervals[0]

  for (let i = 1; i < unixIntervals.length; i += 1) {
    if (previous[1] >= unixIntervals[i][0]) {
      previous = [previous[0], Math.max(previous[1], unixIntervals[i][1])]
    } else {
      result.push(previous)
      previous = unixIntervals[i]
    }
  }

  result.push(previous)

  return result
}

export const getDateTimeTexts = (date) => {
  const day = date.toLocaleString('en-US', { day: 'numeric' })
  const month = date.toLocaleString('en-US', { month: 'long' })
  const monthShort = date.toLocaleString('en-US', { month: 'short' })
  const weekday = date.toLocaleString('en-US', { weekday: 'short' })
  const weekdayLong = date.toLocaleString('en-US', { weekday: 'long' })
  const time = date.toLocaleString('en-US', { timeStyle: 'short' })
  return {
    day,
    month,
    monthShort,
    weekday,
    weekdayLong,
    time,
  }
}

export const formatDate = (date, inputFormat, outputFormat) => {
  return moment(date, inputFormat).format(outputFormat)
}
